module.exports = "/packs/cancel_lesson_banner_pc-9cf6435d62a1e6ebfda5e3db8da4d86d.png";